import { Component, input } from '@angular/core';

import { DetailsValueComponent } from '@iw/common';

import { BankINR, WithdrawalReq } from '../../../entities';

@Component({
  selector: 'iw-bank-transfer-inr-details',
  imports: [DetailsValueComponent],
  templateUrl: './bank-transfer-inr-details.component.html',
  styleUrl: './bank-transfer-inr-details.component.scss',
})
export class BankTransferInrDetailsComponent {
  withdrawalInfo = input.required<WithdrawalReq>();

  get details(): BankINR {
    return this.withdrawalInfo().details as BankINR;
  }
}
